/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
export default [
  {
    width: 180,
    label: '项目参与人',
    tip: '请输入关键字',
    key: 'fullName',
    id: 'fullName',
    slot: 'input',
    maxLength: 10,
    input: value => {
      return `${value}`.replace(/[^\u4E00-\u9FA5]/g, '');
    }
  },
  {
    width: 180,
    label: '手机号',
    tip: '请输入手机号',
    key: 'phone',
    id: 'phone',
    slot: 'input',
    maxLength: 11,
    input: value => {
      const _value = `${value}`;
      if (/^1/g.test(_value)) {
        return _value.replace(/[^0-9]/g, '');
      } else {
        return '';
      }
    }
  },
  {
    width: 180,
    label: '任务月度',
    id: 'monthrange',
    tip: '请选择任务月度',
    required: false,
    slot: 'monthrange',
    format: 'yyyy-MM',
    rangeValue: [],
    key: ['startDt', 'endDt']
  }
];
